import { LoadableComponent } from "@loadable/component";
import { ResourceStore } from "i18next";
import { StaticPageDTO } from "./repositories/static_elements/StaticPageRepository";

export interface RouteCtx {
  query: Record<string, string | undefined>;
  params: Record<string, string | undefined>;
  url: string;
}

export interface RouteConfig {
  path: string;
  exact?: boolean;
  component: LoadableComponent<any>;
  hook?: string | string[];
}

export interface InitialPropsArgs {
  [index: string]: unknown;
  hostApi: string;
  route: RouteCtx;
  i18n: I18nContextObj;
}

export interface I18nContextObj {
  store: ResourceStore;
  lng: string;
  id: number;
}

export interface DefaultContextProps {
  context: InitialPropsArgs;
}

export interface StaticPageContextProps {
  context: {
    staticPage: StaticPageDTO;
    staticContents?: Record<string, string>;
  };
}

export interface InitialPropsResult {
  statusCode?:number;
  redirect?: string;
  links?: Record<string, string | undefined>;
  disableHydratation?: boolean;
}

export class ServerError extends Error {
  public code: number;

  public constructor(code: number, msg?: string) {
    super(msg)

    this.code = code;
  }
}

export class NotFoundError extends ServerError {

  public redirectToNotFoundPage: boolean;

  public constructor(redirectToNotFoundPage: boolean = true) {
    super(404, `Ressource not found`);

    this.redirectToNotFoundPage = redirectToNotFoundPage;
  }
}

export class ValidationError extends ServerError {
  public constructor(error: string) {
    super(400, error);
  }
}
